import { Link } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";

// Rappel discret et incitatif, cohérent avec le bandeau d'accueil.
// Placé en bas des fiches, offres et publications (hors blog).
export function SuggestLink({ className = "" }) {
  return (
    <div className={`mt-10 pt-5 border-t border-slate-100 ${className}`} data-testid="suggest-link-block">
      <Link
        to="/suggestions"
        className="inline-flex items-start gap-1.5 text-xs text-slate-400 hover:text-[#E05638] transition-colors"
        data-testid="suggest-link"
      >
        <Lightbulb size={13} className="mt-0.5 shrink-0" />
        <span>
          Une pépite locale à partager ? Commerce, asso, club ou CSE —{" "}
          <span className="underline">suggérez-la</span>, c'est gratuit.
        </span>
        <ArrowRight size={12} className="mt-0.5 shrink-0" />
      </Link>
    </div>
  );
}

export default SuggestLink;
